import axios from 'axios'
import { message } from 'ant-design-vue'
import router from '@/router'

//axios.defaults.baseURL = 'http://10.23.21.37:18080/api'
// axios.defaults.baseURL = 'http://pipe.njszy.com/api'   // 现线上测试服务器
axios.defaults.baseURL = 'http://wsd.njszy.com/api'        // 现线上服务器
// axios.defaults.baseURL = 'http://223.75.200.168:38400/api' // 枣阳服务器
// axios.defaults.baseURL = 'http://127.0.0.1:19000'   // 本地测试


if (process.env.NODE_ENV === 'production') {
    axios.defaults.baseURL = window.location.protocol + '//' + window.location.host + '/api'
}


const instance = axios.create({
})

instance.interceptors.request.use(function (config) {

    config.headers = {
        token: window.localStorage.getItem('token'),
    }

    return config;
}, function (error) {
    return Promise.reject(error)
})

instance.interceptors.response.use(
    response => {
        // 🔴 如果是 blob，直接返回整个 response，不要再 data.data
        if (response.config.responseType === 'blob') {
            return response;
        }

        const { data = {} } = response;
        if (response.status === 201) message.success('操作成功');
        return data.data ?? {};   // 普通接口保持原逻辑
    },

    error => {
        // blob 出错时把二进制读成文本，再抛业务提示
        if (error.config?.responseType === 'blob' && error.response) {
            return new Promise((resolve, reject) => {
                const reader = new FileReader();
                reader.onload = () => {
                    try {
                        const err = JSON.parse(reader.result);
                        message.error(err.message || '导出失败');
                    } catch {
                        message.error('导出失败');
                    }
                    reject(error);
                };
                reader.readAsText(error.response.data);
            });
        }

        const { status, data } = error.response;
        message.error(data?.message || '异常错误');
        if (status === 401) router.push('/login');
        return Promise.reject(error);
    }
);

export default instance;